import { useState } from "react"
import { createModel } from "hox"

function useQuota() {
  const [quota, setQuota] = useState<number>(0)

  return {
    quota,
    setQuota,
  }
}

export default createModel(useQuota)
